import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromPanelReducer from './panel.reducer';

export const PANEL_STORE_KEY = 'PANEL_STORE';

export const getPanelState =
  createFeatureSelector<fromPanelReducer.PanelState>(PANEL_STORE_KEY);

export const getPanelPageState = createSelector(
  getPanelState,
  (state) => state
);
export const getAnalyticsData = createSelector(
  getPanelPageState,
  (panel) => panel.analytics.data
);
export const getAnalyticsLoading = createSelector(
  getPanelPageState,
  (panel) => panel.analytics.isLoading
);
export const getAnalyticsSuccess = createSelector(
  getPanelPageState,
  (panel) => panel.analytics.success
);
export const getAnalyticsError = createSelector(
  getPanelPageState,
  (panel) => panel.analytics.error
);
export const getAnalyticsFetched = createSelector(
  getPanelPageState,
  (panel) => panel.analytics.fetched
);



export const getEcwidStadisticsState = createSelector(
  getPanelState,
  (state) => state.ecwidData
);
export const getEcwidStadisticsData = createSelector(
  getEcwidStadisticsState,
  (ecwid) => ecwid.data
);
export const getEcwidStadisticsLoading = createSelector(
  getEcwidStadisticsState,
  (ecwid) => ecwid.isLoading
);
export const getEcwidStadisticsSuccess = createSelector(
  getEcwidStadisticsState,
  (ecwid) => ecwid.success
);
export const getEcwidStadisticsError = createSelector(
  getEcwidStadisticsState,
  (ecwid) => ecwid.error
);
export const getEcwidStadisticsFetched = createSelector(
  getEcwidStadisticsState,
  (ecwid) => ecwid.fetched
);